// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, browser:true, react:true*/
import React, {useContext, useState, Fragment} from 'react';
import {Button} from '../lib/button';
import {use_translation_v} from '../lib/trans_v';
import styles from './plans_as_boxes.module.less';
import {Settings_context} from '../settings_ctx';
import {i_plan, i_plan_display_options, i_plan_extended, i_plan_payment_info,
    i_plus_context_store} from './plus_types';
import cn from 'classnames';
import {format_price} from 'zcountry';
import _sortBy from 'lodash.sortby';
// @ts-ignore
import {get_price_plan, get_per}
    from '../../../../svc/account/pub/membership.js';
import {Plus_store_provider, use_plus_store} from './plus_context';
// @ts-ignore
import {get_plan_display_options}
    from '../../../../svc/vpn/pub/common_ui.js';

export type plan_label_type = 'best'|'popular'

const get_plan_label_type = (store: i_plus_context_store, plan: i_plan):
    plan_label_type | undefined=>{
    if (store.plans.length < 2)
        return;
    if (plan.id === store.best_id)
        return 'best';
    if (plan.id === store.popular_id)
        return 'popular';
    return;
};

const plan_order_pred = (label_type: plan_label_type):
    number=>{
    const val = {best: 2, popular: 1};
    return val[label_type]||0;
};

const Plan_badge = ({type}: {type?: plan_label_type})=>{
    const {theme} = useContext(Settings_context);
    const {t} = use_translation_v({version: 0});
    const type_to_style = {
        best: {style: styles.best_value, text: t('Best Value')},
        popular: {style: styles.most_popular, text: t('Most popular')},
    };
    const {style, text} = type_to_style[type]||{};
    return <div className={styles.type_badge_container}>
      <p className={cn(theme.xs, styles.type_badge, style)}>{text}</p>
    </div>;
};

interface i_plan_pricing_section_props {
    plan: i_plan_extended;
    price_o: i_plan_payment_info;
    currency?: string;
}

const Plan_pricing_section = ({currency, plan, price_o}:
    i_plan_pricing_section_props)=>{
    const {every} = plan;
    const {price, regular_price} = price_o;
    const {theme} = useContext(Settings_context);
    const {T} = use_translation_v({version: 0});
    const {show_line_through_regular_price, show_renewal_billing_label}
        = get_plan_display_options(plan) as i_plan_display_options;
    const pricing_regular = show_line_through_regular_price
        ? <Fragment>
            <span className={styles.regular}>
              {format_price(currency, regular_price)}
            </span>
            <span className={styles.price}>
              {format_price(currency, price)}
            </span>
        </Fragment> : null;
    const billed = show_renewal_billing_label
        ? <Fragment><T>for the first {every}</T><sup>*</sup></Fragment>
        : <T>billed every {every}</T>;
    return <div className={cn(styles.pricing,
      !pricing_regular && styles.regular_pricing)}>
      <p className={theme.xs}>
        {pricing_regular}
      </p>
      <p className={cn(theme.xs, styles.billed)}>
        {billed}
      </p>
    </div>;
};

const Plan_content = ({plan}: {plan: i_plan_extended})=>{
    const {theme, theme_name} = useContext(Settings_context);
    const is_hola2023_theme = theme_name=='hola2023';
    const plus_store = use_plus_store();
    const {currency} = plus_store;
    const {t, T} = use_translation_v({version: 0});
    const price_o = get_price_plan(plan, currency);
    const {short_name, free_period, every} = plan;
    const {month_price, price} = price_o;
    const name_cls = cn(styles.plan_name, is_hola2023_theme ?
        [theme.p1, theme.med, theme.primary] : [theme.bold, theme.grey_1]);
    const month_cls = is_hola2023_theme ? cn(theme.p5, theme.med) :
        cn(theme.xs, theme.grey_1);
    const Price_tag = is_hola2023_theme ? 'h5' : 'h2';
    return <div className={styles.plan_content}>
      <p className={name_cls}>
        {is_hola2023_theme ? <T>{short_name}</T> :
          <b><T>{short_name}</T></b>}
        {free_period && <span className={styles.price_free}>
          + {get_per(free_period, true)} free
        </span>}
      </p>
      {(month_price||price) && <div className={styles.monthly_price}>
        <Price_tag className={styles.monthly_value}>
          {format_price(currency, month_price||price)}</Price_tag>
        <p className={month_cls}>/ {t(month_price ? 'month' : every)}</p>
      </div>}
      <Plan_pricing_section plan={plan} currency={currency} price_o={price_o}/>
    </div>;
};

interface i_plan_box_props {
    plan: i_plan_extended;
    key?: React.Key;
    cta_text?: string;
}

const Plan_box = ({plan, cta_text, ...props}: i_plan_box_props)=>{
    const {theme_name} = useContext(Settings_context);
    const is_hola2023_theme = theme_name=='hola2023';
    const plus_store = use_plus_store();
    const [is_hovered, set_is_hovered] = useState(false);
    const {set_plan, open_payment_form} = plus_store;
    const {t} = use_translation_v({version: 0});
    const label_type = get_plan_label_type(plus_store, plan);
    const handle_select = ()=>{
        set_plan(plan);
        open_payment_form();
    };
    const handle_mouse_enter = ()=>set_is_hovered(true);
    const handle_mouse_leave = ()=>set_is_hovered(false);
    const btn_color = is_hola2023_theme ? 'transparent' :
        is_hovered ? undefined : 'white';
    const cls = cn(styles.box_container, {
        [styles.jump_on_hover]: !is_hola2023_theme,
    });
    const wrapper_cls = cn(styles.box_wrapper, styles[label_type]);
    return <div className={wrapper_cls}><div {...props} className={cls}
      onClick={handle_select} onMouseEnter={handle_mouse_enter}
      onMouseLeave={handle_mouse_leave} data-plan-id={plan.id}
        data-plan={plan.period?.replace(/\s/g, '').toLowerCase()}>
        {is_hola2023_theme && label_type=='popular' ? null :
          <Plan_badge type={label_type}/>}
        <div className={styles.payout_layout}>
          <Plan_content plan={plan}/>
          <Button caption={cta_text || t('Select')} arrow={!is_hola2023_theme}
            size={is_hola2023_theme ? undefined : 'sm'}
            cls={styles.btn_select} color={btn_color}/>
        </div>
    </div><div className={styles.underlay}/></div>;
};

export interface i_plans_as_boxes_trans {
    title?: string;
    subtitle?: string;
    cta?: string;
}

interface i_plans_as_boxes_impl_props {
    trans: i_plans_as_boxes_trans;
    class_name?: string;
}
export const Plans_as_boxes_impl = (props: i_plans_as_boxes_impl_props)=>{
    const {trans, class_name} = props;
    const {theme, theme_name} = useContext(Settings_context);
    const Title_tag = theme_name=='hola2023' ? 'h4' : 'h2';
    const plus_store = use_plus_store();
    const {plans} = plus_store;
    const ordered_plans = _sortBy(plans, plan=>{
        const label_type = get_plan_label_type(plus_store, plan);
        return plan_order_pred(label_type);
    });
    return <div className={cn(styles.root, class_name, styles[theme_name])}>
      <Title_tag className={styles.title}>{trans.title}</Title_tag>
      {trans.subtitle && <p className={cn(theme.p1, styles.subtitle)}>
        {trans.subtitle}</p>}
      <div className={styles.boxes_grid}>
        {ordered_plans.map(plan=><Plan_box key={plan.id} plan={plan}
          cta_text={trans.cta}/>)}
      </div>
    </div>;
};

interface i_plans_as_boxes_props extends i_plus_context_store {
    trans: i_plans_as_boxes_trans;
    key?: React.Key;
    class_name?: string;
}

export const Plans_as_boxes = ({trans, class_name, ...props}:
    i_plans_as_boxes_props)=>{
    return <Plus_store_provider value={props}>
      <Plans_as_boxes_impl trans={trans} class_name={class_name}/>
    </Plus_store_provider>;
};
